import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSavedReports, selectSavedReports, selectLoading } from "../redux/savedReports";

export function useSavedReports() {
    const dispatch = useDispatch();
    const savedReports: Report[] = useSelector(selectSavedReports);
    const loading = useSelector(selectLoading);

    useEffect(() => {
        dispatch(fetchSavedReports());
    }, [ dispatch ]);

    return {
        state: { savedReports },
        loading,
    };
}
